import * as React from "react";

function SvgGridBasic(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 66 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#959595" d="M12 8h42v56H12z" />
    </svg>
  );
}

export default SvgGridBasic;